import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../colors-v2';
import { useFromScreens } from '../../../../hooks/useDeviceQuery.hook';
import { LandingLayoutDefault, LandingLayoutDefaultProps } from './LandingLayoutDefault';
import { JuniorPromotionBanner } from '../ui/JuniorPromotionBanner/JuniorPromotionBanner';

const Main = styled.div`
  #left-interaction-sidebar {
    color: ${colorsV2.white100};
  }

  #layout-landing-content {
    padding-bottom: 0;
  }
`;

interface LandingLayoutDailyLearningProps extends LandingLayoutDefaultProps {
  className?: string;
}

export const LandingLayoutDailyLearning = (props: LandingLayoutDailyLearningProps) => {
  const { className, ...rest } = props;
  const [, from1024] = useFromScreens([0, 1024]);

  return (
    <Main className={cl('landing-layout-daily-learning', className)}>
      <JuniorPromotionBanner />
      <LandingLayoutDefault logoColored withFooter={!from1024} {...rest} />
    </Main>
  );
};
